import React from "react";
import { Route, Switch } from "react-router-dom";

import AppliedRoute from "./components/AppliedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import Home from "./containers/Home";
import Ideas from "./containers/Ideas";
import Login from "./containers/Login";
import NewIdea from "./containers/NewIdea";
import NotFound from "./containers/NotFound";
import Plans from "./containers/Plans";
import Signup from "./containers/Signup";

export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path="/" exact component={Home} props={childProps} />
    <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
    <UnauthenticatedRoute path="/signup" exact component={Signup} props={childProps} />
    <AuthenticatedRoute path="/ideas/new" exact component={NewIdea} props={childProps} />
    <AuthenticatedRoute path="/ideas/:id" exact component={Ideas} props={childProps} />
    <AuthenticatedRoute path="/ideas/:id/plans/:tripId" exact component={Plans} props={childProps} />
    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;
